import { render, staticRenderFns } from "./wayofqilins.vue?vue&type=template&id=07771605&scoped=true"
import script from "./wayofqilins.vue?vue&type=script&lang=js"
export * from "./wayofqilins.vue?vue&type=script&lang=js"
import style0 from "./wayofqilins.vue?vue&type=style&index=0&id=07771605&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07771605",
  null
  
)

export default component.exports